import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    profileType: String,
    profileId: Number
  }

  declare urlValue: string
  declare profileTypeValue: string
  declare profileIdValue: number

  connect() {
    this.element.addEventListener("change", this.update.bind(this))
  }

  async update(event: Event) {
    const select = event.target as HTMLSelectElement
    const status = select.value

    try {
      select.disabled = true

      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || ""
        },
        body: JSON.stringify({
          profile_type: this.profileTypeValue,
          profile_id: this.profileIdValue,
          status: status
        })
      })

      if (!response.ok) {
        throw new Error("Failed to update status")
      }

      // Brief visual feedback
      select.classList.add("ring-2", "ring-green-500")
      setTimeout(() => {
        select.classList.remove("ring-2", "ring-green-500")
      }, 500)
    } catch (error) {
      console.error("Error updating quality status:", error)
      select.classList.add("ring-2", "ring-red-500")
      setTimeout(() => {
        select.classList.remove("ring-2", "ring-red-500")
      }, 1000)
    } finally {
      select.disabled = false
    }
  }
}
